import PropTypes, { number } from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse, Modal, Table, Row, Col } from "reactstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import "../../assets/css/Layout/Header.css";
//i18n
import { withTranslation } from "react-i18next";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import { connect } from "react-redux";
import axios from "axios";
import configure from "configure";
import Select from "react-select";
import { isNaN } from "lodash";
import Loader from "pages/Separate/Loader";
import ReactSelect from "react-select";
import { fetchNodeData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import VerionHistory from "./Version/versionHistory";

const Navbar = (props) => {
  const [expense, setExpense] = useState(false);
  const [margin, setMargin] = useState({ value: 1.5, label: 1.5 });
  const [marginOption, setMarginOption] = useState([
    {
      value: 1.5,
      label: 1.5,
    },
    {
      value: 2,
      label: 2,
    },
    {
      value: 2.5,
      label: 2.5,
    },
  ]);
  const [dashboard, setdashboard] = useState(false);
  const [setting, setSetting] = useState(false);
  const [allcurrency, setAllCurrency] = useState([]);
  const [allTechData, setAllTechData] = useState([]);
  const [currency, setCurrency] = useState({
    label: "INR",
    value: "INR",
    symbol: "₹",
  });
  const [addCallingModal, setAddCallingModal] = useState(false);
  const [fixedContent, setFixedContent] = useState(false);

  const [isLoading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const [subTotal, setSubTotal] = useState(0);
  const [profit, setProfit] = useState("");
  const [finalCost, setFinalCost] = useState(0);

  useEffect(() => {
    RolesPermission();
    // fetchCurrency()
  }, []);
  const handleChange = (selectedOption) => {
    setMargin(selectedOption);
  };

  useEffect(() => {
    const tempData = [...allTechData];
    setAllTechData(
      tempData.map((tech) => ({
        ...tech,
        estimate_cost: tech.days * tech[currency.value],
      })),
    );
  }, [currency, margin]);

  useEffect(() => {
    setSubTotal(allTechData.reduce((acc, curr) => acc + curr.estimate_cost, 0));
  }, [allTechData]);

  useEffect(() => {
    setFinalCost(subTotal + (subTotal * profit) / 100);
  }, [subTotal]);

  const fetchCurrency = async () => {
    setLoading(true);
    setAddCallingModal(true);

    try {
      await axios({
        method: "get",
        url: `${configure.nodeApi}/currency`,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then((res) => {
        setLoading(false);
        setAllCurrency(
          res.data.currency.map((curr) => ({
            label: curr.currency,
            value: curr.currency,
            symbol: curr.symbol,
          })),
        );

        // call show technologies api
        showTechnologiesData();
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const showTechnologiesData = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/show_technologies`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(async (response) => {
        if (response.data.data.length > 0) {
          const datas = Array(response.data.data[0].currency_value) ? response.data.data[0].currency_value : JSON.parse(response.data.data[0].currency_value);

          setAllTechData(
            datas.map((data) => ({
              ...data,
              days: "",
              estimate_cost: 0,
            })),
          );
        }
        setAddCallingModal(true);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeDays = (value, index) => {
    const tempData = [...allTechData];

    setAllTechData(
      tempData.map((tech, i) => {
        if (i == index) {
          tech.days = value;
          tech.estimate_cost = value * tech[currency.value];
        }
        return tech;
      }),
    );
  };

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 50,
    }),
  };

  const RolesPermission = async (e) => {
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/staff_roles`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: formData,
      }).then((response) => {
        setRoles(response.data.data.map((item) => JSON.parse(item.permission)));
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  function filterInnerArraysById(id) {
    return roles.map((innerArray) => {
      return innerArray.filter((element) => {
        const parts = element.split(",");
        const elementId = parseInt(parts[0]);
        return elementId === id;
      });
    });
  }

  const ids = [3, 24, 4, 5, 6];

  const output = roles.map((innerArray) =>
    innerArray.filter((element) => {
      const parts = element.split(",");
      const elementId = parseInt(parts[0]);
      return ids.includes(elementId);
    }),
  );
  const output2 = output.map((innerArray) => {
    const element = innerArray[1]; // Get the element at index 2 (0-based indexing)
    const parts = element.split(",");
    return parts.map((part) => parseInt(part)); // Convert to integers
  });

  const calenderUrl = useLocation();

  const calender3 = calenderUrl.pathname;
  const usepara = useParams();
  const filterRole =
    localStorage.getItem("auth_role") == 1 ||
      localStorage.getItem("auth_role") == 11 ||
      localStorage.getItem("auth_role") == 4
      ? true
      : false;

  const [shouldShow, setShouldShow] = useState(false);
  const token = secureLocalStorage.getItem("auth_token");
  const [modalOpen, setModalOpen] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [news, setNews] = useState("");
  const [versions, setVersions] = useState([]);
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.95);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();

    const isTuesdayOrThursday = day === 2 || day === 4;
    const isAfter3PM = hour >= 15;

    if (isTuesdayOrThursday && isAfter3PM) {
      const fetchCurrentVersion = async () => {
        try {
          const res = await fetchNodeData(() => { }, "currentVersion", token);
          if (res?.success) {
            const today = new Date();
            const todayStr = today.toISOString().split("T")[0];
            setNews(
              res.data.updateType == "new module"
                ? "🔥 Huge Release Dropped! New modules, fixes & more – check the log."
                : res.data.updateType == "updation"
                  ? "✨ New Features Unlocked! See what’s changed in today’s update."
                  : res.data.updateType == "bug fix"
                    ? "🚨 Bug Fix Alert! We’ve rolled out updates – check if your issue is fixed."
                    : "🚀 Today’s the Day! Discover Our Exciting New Release – Now Live! Experience Innovation at Its Best. 🌟",
            );
            if (res?.data.date == todayStr) {
              setShouldShow(true);
            }
          }
        } catch (err) {
          console.error("Failed to fetch current version:", err);
        }
      };
      fetchCurrentVersion();
    }
  }, []);

  const handleOpenModal = async () => {
    try {
      const res = await fetchNodeData(() => { }, "versionControl/");
      if (res.success && res.data) {
        setVersions(res.data.versionData || []);
        setModalOpen(true);
      }
    } catch (err) {
      console.error("Failed to fetch version history:", err);
    }
  };

  return (
    <React.Fragment>
      <div
        className={`topnav ps-1 pe-0 ${calender3 === `${configure.appUrl}calendar` ||
          calender3 === `${configure.appUrl}calender/${usepara.id}`
          ? "d-none"
          : ""
          }`}
        style={{ zIndex: "1001" }}
      >
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none text-dark"
                      to={`${configure.appUrl}dashboard`}
                    >
                      <i className="bx bx-home-circle me-2 "></i>
                      {props.t("Dashboard")} {props.menuOpen}
                    </Link>
                  </li>

                  {/* Leads */}
                  {filterInnerArraysById(17)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ||
                    filterInnerArraysById(17)
                      .map((item) => item[0]?.split(",").map(Number)[1])
                      .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none text-dark"
                        to="#"
                        onClick={() => toggleMenu(1)}
                      >
                        <i className="fa fa-user-plus me-2"></i>
                        {props.t("Leads")} {props.menuOpen}
                        <span className="arrow-down"></span>
                      </Link>

                      <div className={`dropdown-menu`} id="sales-dropdown" style={{ overflow: "visible" }}>

                        <Link
                          to={`${configure.appUrl}sales/lead`}
                          className="dropdown-item w-100"
                        >
                          Regular Leads
                        </Link>

                        <Link
                          to={`${configure.appUrl}sales/opportunity-leads`}
                          className="dropdown-item"
                        >
                          Opportunity Leads
                        </Link>

                        <Link
                          to={`${configure.appUrl}sales/junk-leads`}
                          className="dropdown-item"
                        >
                          Junk Leads
                        </Link>
                      </div>
                    </li>
                  ) : null}

                  <>
                    {/* {filterInnerArraysById(18)
                      .map((item) => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <li className="nav-item dropdown">
                        <Link
                          to={`${configure.appUrl}sales/introducer`}
                          className="nav-link dropdown-toggle arrow-none "
                          style={{ overflow: "hidden" }}
                        >
                          <i className="fa fa-user-friends  me-2 "></i>
                          Introducer
                        </Link>
                      </li>
                    ) : null} */}

                    {filterInnerArraysById(19)
                      .map((item) => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <li className="nav-item dropdown">
                        <Link
                          to={`${configure.appUrl}sales/proposal`}
                          className="nav-link dropdown-toggle arrow-none "
                          style={{ overflow: "hidden" }}
                        >
                          <i className="fa fa-file-alt  me-2 "></i>
                          Proposal
                        </Link>
                      </li>
                    ) : null}

                    {filterInnerArraysById(20)
                      .map((item) => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <li className="nav-item dropdown">
                        <Link
                          to={`${configure.appUrl}sales/contract`}
                          className="nav-link dropdown-toggle arrow-none "
                          style={{ overflow: "hidden" }}
                        >
                          <i className="fa fa-file-signature  me-2 "></i>
                          Contract
                        </Link>
                      </li>
                    ) : null}

                    {/* {filterInnerArraysById(21)
                      .map((item) => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ? (
                      <li className="nav-item dropdown">
                        <Link
                          to={`${configure.appUrl}sales/customer`}
                          className="nav-link dropdown-toggle arrow-none "
                          style={{ overflow: "hidden" }}
                        >
                          <i className="fa fa-users  me-2 "></i>
                          Customers
                        </Link>
                      </li>
                    ) : null} */}



                    {/* Portfolio */}
                    {filterInnerArraysById(18)
                      .map((item) => item[0]?.split(",").map(Number)[2])
                      .includes(1) == true ||
                      filterInnerArraysById(21)
                        .map((item) => item[0]?.split(",").map(Number)[2])
                        .includes(1) == true ? (
                      <li className="nav-item dropdown">
                        <a
                          className="nav-link dropdown-toggle arrow-none"
                          id="topnav-more"
                          type="button"
                          onClick={() => toggleMenu(10)}
                        >
                          <i className="fa fa-users me-2"></i>
                          <span>Customers</span>
                          <span className="arrow-down"></span>
                        </a>
                        <div
                          className={`dropdown-menu active `}
                          aria-labelledby="topnav-more"
                        >
                          <div className="dropdown">

                            {filterInnerArraysById(21)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}sales/customer`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Customers</span>
                              </Link>
                            ) : null}

                            {filterInnerArraysById(18)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <Link
                                className="dropdown-item dropdown-toggle arrow-none"
                                to={`${configure.appUrl}sales/introducer`}
                                id="topnav-invoice"
                                role="button"
                              >
                                <span>Introducer</span>
                              </Link>
                            ) : null}
                          </div>
                        </div>
                      </li>
                    ) : null}
                  </>

                  {/* Marketing */}
                  {filterInnerArraysById(3)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none text-dark"
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpense(!expense);
                          toggleMenu(2);
                        }}
                      >
                        <i className="fas fa-bullhorn me-2"></i>
                        {props.t("Marketing")}
                        <span className="arrow-down"></span>
                      </Link>
                      <div className={`dropdown-menu `}>
                        {filterInnerArraysById(22)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            to={`${configure.appUrl}marketing/opportunity`}
                            className="dropdown-item arrow-none"
                          >
                            {props.t("Opportunity")}{" "}
                          </Link>
                        ) : null}

                        {filterInnerArraysById(24)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            to={`${configure.appUrl}marketing/cold-calling`}
                            className="dropdown-item"
                          >
                            Cold Calling
                          </Link>
                        ) : null}

                        {filterInnerArraysById(87)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            to={`${configure.appUrl}marketing/all-bookings`}
                            className="dropdown-item arrow-none"
                          >
                            {props.t("Bookings")}{" "}
                          </Link>
                        ) : null}

                        {filterInnerArraysById(112)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            to={`${configure.appUrl}marketing/tender`}
                            className="dropdown-item arrow-none"
                          >
                            {props.t("Tender")}{" "}
                          </Link>
                        ) : null}

                        {filterInnerArraysById(23)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            to={`${configure.appUrl}marketing/bidding`}
                            className="dropdown-item arrow-none"
                          >
                            {props.t("Bidding")}{" "}
                          </Link>
                        ) : null}
                      </div>
                    </li>
                  ) : null}

                  {/* Work MODULE  */}
                  {filterInnerArraysById(4)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle arrow-none"
                        id="topnav-more"
                        type="button"
                      >
                        <i className="bx bx-task me-2"></i>
                        <span key="t-extra-pages">Work</span>
                        <span className="arrow-down"></span>
                      </a>
                      <div
                        className={`dropdown-menu active`}
                        aria-labelledby="topnav-more"
                      >
                        {filterInnerArraysById(25)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <div className="dropdown">
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              id="topnav-auth"
                              role="button"
                            >
                              <span>Development Project</span>
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="topnav-form"
                              style={{ overflow: "hidden" }}
                            >

                              {filterInnerArraysById(88)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}initial-project-plan/development`}
                                  className="dropdown-item"
                                  style={{ overflow: "hidden" }}
                                >
                                  Initial Project Plan
                                </Link>
                              ) : null}
                            </div>
                          </div>
                        ) : null}

                        {filterInnerArraysById(97)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <div className="dropdown">
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              id="topnav-auth"
                              role="button"
                            >
                              <span key="t-work">Digital Marketing</span>
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="topnav-form"
                              style={{ overflow: "hidden" }}
                            >
                              {filterInnerArraysById(100)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}initial-project-plan/digital-marketing`}
                                  className="dropdown-item"
                                  style={{ overflow: "hidden" }}
                                >
                                  Initial Project Plan
                                </Link>
                              ) : null}
                            </div>
                          </div>
                        ) : null}

                        {filterInnerArraysById(26)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}work/activities`}
                            id="topnav-utility"
                            role="button"
                          >
                            <span key="t-work">Activities</span>
                          </Link>
                        ) : null}
                        {filterInnerArraysById(29)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}work/hosting`}
                            id="topnav-utility"
                            role="button"
                          >
                            <span>Hosting</span>
                          </Link>
                        ) : null}
                      </div>
                    </li>
                  ) : null}

                  {filterInnerArraysById(6)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle arrow-none"
                        id="topnav-more"
                        type="button"
                        onClick={() => toggleMenu(6)}
                      >
                        <i className="bi bi-file-earmark-text me-2"></i>
                        <span key="t-extra-pages">Reports</span>
                        <span className="arrow-down"></span>
                      </a>
                      <div
                        className={`dropdown-menu active`}
                        aria-labelledby="topnav-more"
                      >
                        {filterInnerArraysById(96)
                          .map((item) => item[0]?.split(",").map(Number)[2])
                          .includes(1) == true ? (
                          <Link
                            className="dropdown-item dropdown-toggle arrow-none"
                            to={`${configure.appUrl}flaws-gap`}
                            id="topnav-invoice"
                            role="button"
                          >
                            <span key="t-invoices">Flaws & Gaps</span>
                          </Link>
                        ) : null}

                      </div>
                    </li>
                  ) : null}

                  {/* Portfolio */}
                  {filterInnerArraysById(112)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle arrow-none"
                        id="topnav-more"
                        type="button"
                        onClick={() => toggleMenu(10)}
                      >
                        <i className="fas fa-briefcase  me-2"></i>
                        <span>Portfolio</span>
                        <span className="arrow-down"></span>
                      </a>
                      <div
                        className={`dropdown-menu active `}
                        aria-labelledby="topnav-more"
                      >
                        <div className="dropdown">
                          {filterInnerArraysById(113)
                            .map((item) => item[0]?.split(",").map(Number)[2])
                            .includes(1) == true ? (
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${configure.appUrl}case-study`}
                              id="topnav-invoice"
                              role="button"
                            >
                              <span>New Projects</span>
                            </Link>
                          ) : null}
                          {filterInnerArraysById(114)
                            .map((item) => item[0]?.split(",").map(Number)[2])
                            .includes(1) == true ? (
                            <Link
                              className="dropdown-item dropdown-toggle arrow-none"
                              to={`${configure.appUrl}portfolio`}
                              id="topnav-invoice"
                              role="button"
                            >
                              <span>Create Portfolio</span>
                            </Link>
                          ) : null}
                        </div>
                      </div>
                    </li>
                  ) : null}
                </div>

                {/* end modules  */}
                <div className="d-flex gap-3 align-items-center">

                  {filterInnerArraysById(7)
                    .map(item => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <div
                        className=" dropdown-toggle cursor-pointer p-0 border-0 bg-transparent "
                        id="topnav-more"
                      // onClick={() => toggleMenu(3)}
                      >
                        <i
                          className="fa fa-globe "
                          style={{ fontSize: "12px" }}
                        ></i>
                      </div>
                      <div
                        className={`dropdown-menu overflow-hidden  `}
                        aria-labelledby="topnav-more"
                        style={{ left: "-50px" }}
                      >
                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://hr.zithas.in`}
                          target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>HR</span>
                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`#`}
                          // target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Work</span>

                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://accounts.zithas.in`}
                          target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Finance India</span>
                        </a>

                        <a
                          className="dropdown-item dropdown-toggle d-flex gap-3"
                          href={`https://accounts.zithas.com`}
                          target="_blank"
                          rel="noreferrer"
                          id="topnav-invoice"
                          role="button"
                        >
                          <i className="fa fa-arrow-right alert alert-success rounded-circle mb-0 p-1"></i>
                          <span>Finance USA</span>
                        </a>

                      </div>
                    </li>
                  ) : null}

                  {/* setting  */}
                  {filterInnerArraysById(13)
                    .map((item) => item[0]?.split(",").map(Number)[2])
                    .includes(1) == true ? (
                    <li className="nav-item dropdown">
                      <Link className="nav-link dropdown-toggle arrow-none text-dark mt-1 p-0">
                        <i className="bx bx-cog setting-icon"></i>
                      </Link>
                      <div
                        className={classname("dropdown-menu ", {
                          show: setting,
                        })}
                        style={{ width: "300px" }}
                      >
                        <div className="row flex-wrap py-2 overflow-hidden">
                          <div className="col-md-5 overflow-hidden">
                            <h6 className="ps-4 mt-2 fw-bold">Sales</h6>

                            {filterInnerArraysById(73)
                              .map((item) => item[0]?.split(",").map(Number)[2])
                              .includes(1) == true ? (
                              <li>
                                <Link
                                  to={`${configure.appUrl}setting/lead`}
                                  className="dropdown-item"
                                >
                                  {props.t("Leads")}
                                </Link>
                              </li>
                            ) : null}

                            <li>
                              {filterInnerArraysById(75)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/introducer`}
                                  className="dropdown-item"
                                >
                                  {props.t("Introducer")}
                                </Link>
                              ) : null}
                            </li>

                            <li>
                              {filterInnerArraysById(76)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/contract`}
                                  className="dropdown-item"
                                >
                                  {props.t("Contract")}
                                </Link>
                              ) : null}
                            </li>

                            {/* New  */}
                            <li>
                              {!filterInnerArraysById(120)
                                .map((item) => item[0]?.split(",").map(Number)[2])
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/rfp`}
                                  className="dropdown-item"
                                >
                                  {props.t("RFP Permissions")}
                                </Link>
                              ) : null}
                            </li>

                            <li>
                              {filterInnerArraysById(19)
                                .map((item) => item[0]?.split(",").map(Number)[2])
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/proposal`}
                                  className="dropdown-item"
                                >
                                  {props.t("Proposal")}
                                </Link>
                              ) : null}
                            </li>
                          </div>

                          <div className="col-md-6 overflow-hidden">
                            <h6 className="ps-4 mt-2 fw-bold">Marketing</h6>

                            <li>
                              {filterInnerArraysById(72)
                                .map(
                                  (item) => item[0]?.split(",").map(Number)[2],
                                )
                                .includes(1) == true ? (
                                <Link
                                  to={`${configure.appUrl}setting/bidding`}
                                  className="dropdown-item"
                                >
                                  {props.t("Tender/Bidding")}
                                </Link>
                              ) : null}
                            </li>
                          </div>
                        </div>
                      </div>
                    </li>
                  ) : null}

                  {/* credentials  */}
                  <li className="nav-item dropdown">
                    {filterInnerArraysById(10)
                      .map((item) => item[0]?.split(",")?.map(Number)[2])
                      .includes(1) == true ? (
                      <Link
                        to={`${configure.appUrl}credentials`}
                        className="border-radius border-0 btn text-dark fs-5 px-0 mt-1"
                        title="Credentials"
                      >
                        <i className="fa fa-address-card"></i>
                      </Link>
                    ) : null}
                  </li>

                  <li className="nav-item dropdown">
                    {filterInnerArraysById(11)
                      .map((item) => item[0]?.split(",")?.map(Number)[2])
                      .includes(1) == true ? (
                      <button
                        onClick={() => {
                          fetchCurrency();
                        }}
                        className="border-radius bg-transparent border-0 text-dark fs-5 ps-0 mt-1"
                      >
                        <i className="mdi mdi-calculator"></i>
                      </button>
                    ) : null}
                  </li>
                </div>
              </ul>
            </Collapse>
          </nav>
        </div>
        <div>
          {shouldShow ? (
            <div
              className="marquee-container cursor-pointer"
              onClick={() => handleOpenModal()}
            >
              <div className="marquee-text">
                <div className="container-fluid">
                  <div className="d-flex justify-content-center gap-3">
                    <span>{news}</span>
                    <span className="blink-soft">
                      Click Here{" "}
                      <i className="mdi mdi-cursor-default-click PPC-color"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>


      <Modal
        isOpen={addCallingModal}
        size="xl"
        centered
        id="ResourceEstimation"
      >
        <div
          className="modal-header border-bottom-0"
          style={{ backgroundColor: "#730077" }}
        >
          <div className="col-6 ">
            <h5 className="modal-title mt-0 text-white">Resource Estimation</h5>
          </div>
          <div className="col-5 d-flex justify-content-end">
            <div className="col-6 d-flex justify-content-end">
              <Select
                className="basic-multi-select w-50"
                classNamePrefix="border-radius select"
                styles={colourStyles}
                options={allcurrency}
                value={currency}
                onChange={(e) => setCurrency(e)}
              />
            </div>
            <div className="">
              <button
                className="btn btn-red ms-3 btn-label"
                onClick={() => {
                  setCurrency({ label: "INR", value: "INR", symbol: "₹" });
                  setAllTechData(
                    allTechData.map((data) => ({
                      ...data,
                      days: "",
                      estimate_cost: 0,
                    })),
                  );
                  setProfit("");
                }}
              >
                {" "}
                <i className="bi bi-x-circle label-icon"></i> Clear
              </button>
            </div>
          </div>
          <div>
            <button
              type="button"
              onClick={() => {
                setAddCallingModal(false);
              }}
              className="btn-modal-close "
            >
              <span className="btn-modal-span fs-2">&times;</span>
            </button>
          </div>
        </div>
        <div className="modal-body pt-1">
          <div>
            {/* fixed buttons */}
            <div
              className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
                }`}
            >
              <button
                onClick={() => navigate(-1)}
                className="btn btn-red border-radius fix-btn"
              >
                <i className="dripicons-cross me-2 icon-center"></i>
                <span>Cancel</span>
              </button>
            </div>
            <Row className="">
              <Col col={12}>
                <div className="d-flex justify-content-end">
                  <div className=""></div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-end col-md-6"></Col>
              <Col className="d-flex justify-content-end col-md-6">
                <div className=""></div>
              </Col>
            </Row>
            <div
              className="position-relative flow-scroll"
              style={{
                height: "420px",
                overflow: "auto",
                scrollbarWidth: "thin",
              }}
            >
              <Table className="table table-bordered">
                <thead className="position-sticky top-0 left-0 right-0 shadow bg-white">
                  <tr>
                    <th className="col-1 text-center">
                      Id
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-4">
                      Name
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-2 text-center d-none">
                      Per Day
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-1 text-center">
                      Hours
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                    <th className="col-2 text-center">
                      Estimate Cost
                      {/* <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i> */}
                    </th>
                  </tr>
                </thead>
                <tbody className="fix-databank-header">
                  {allTechData.length === 0 && <Loader />}
                  {allTechData.map((tech, index) => {
                    return (
                      <tr className="row-hover" key={index}>
                        <td className="text-center py-1">{index + 1}</td>
                        <td className="py-1">{tech.Technology}</td>
                        <td className="text-center d-none">
                          {
                            tech[
                            Object.keys(tech).filter(
                              (curr) => curr == currency.value,
                            )
                            ]
                          }
                        </td>
                        <td className="py-1 d-flex justify-content-center">
                          <input
                            className="form-control edit_row_m w-75"
                            id="days1"
                            type="text"
                            value={tech.days}
                            onChange={(e) =>
                              handleChangeDays(e.target.value, index)
                            }
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key))
                                event.preventDefault();
                            }}
                          />
                        </td>
                        <td className="text-center py-1">
                          {tech.estimate_cost.toFixed(2)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div
          className="modal-footer p-1 border-top-0"
          style={{ backgroundColor: "#730077" }}
        >
          <div className="w-100">
            <Table className="table table-bordered mb-0">
              <tbody className="fix-databank-header">
                <tr className="">
                  <td className="col-1 fw-bold bg-white text-end">Times</td>
                  <td className=" text-center" style={{ width: "10%" }}>
                    <div className="">
                      <ReactSelect
                        placeholder="Times"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        options={marginOption}
                        value={margin}
                        // onChange={e =>
                        //   setMargin({ value: e.value, label: e.value })
                        // }
                        onChange={handleChange}
                        menuPlacement="top"
                      />
                    </div>
                  </td>
                  <td
                    className="fw-bold bg-white text-end"
                    style={{ width: "10%" }}
                  >
                    Capital Cost
                  </td>
                  <td className="text-center" style={{ width: "12%" }}>
                    {currency.symbol + " " + subTotal.toFixed(2) * margin.value}
                  </td>

                  <td className="col-2 fw-bold bg-white text-end">
                    Profit (%)
                  </td>
                  <td className="col-1 text-center">
                    {" "}
                    <input
                      className="form-control border-1 border-secondary edit_row_m"
                      id="days1"
                      type="text"
                      placeholder="%"
                      value={profit}
                      onChange={(e) => {
                        setProfit(e.target.value);
                        setFinalCost(
                          subTotal + (subTotal * e.target.value) / 100,
                        );
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) event.preventDefault();
                      }}
                    />
                  </td>

                  <td
                    className="col-2 fw-bold bg-white text-end fs-5"
                    style={{ color: "#981f77" }}
                  >
                    Total Cost
                  </td>
                  <td
                    className="col-2 text-center fs-5"
                    style={{ color: "#981f77" }}
                  >
                    {currency.symbol +
                      " " +
                      (finalCost * margin.value).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </Modal>

      <div className={`note-sticky-form ${modalOpen ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "6%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Version History</h5>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <VerionHistory versions={versions} />
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar)),
);
